import { ESilentNotificationsStatusType } from '@features/navigationContainer/components/pushNotificationMenu/enums/notificationStatusType.enum';

export const supportedSilentPushNotification = {
  GENERAL_SETTINGS: ESilentNotificationsStatusType.GENERAL_SETTINGS,
  MATERIAL_PRODUCER: ESilentNotificationsStatusType.MATERIAL_PRODUCER,
  TICKET_TYPES: ESilentNotificationsStatusType.TICKET_TYPES,
  USER_INFO: ESilentNotificationsStatusType.USER_INFO,
};
